import { render, staticRenderFns } from "./ProjectGeneral.vue?vue&type=template&id=db395c58&"
import script from "./ProjectGeneral.vue?vue&type=script&lang=js&"
export * from "./ProjectGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports